import { PocketTypeEnum, RiskLevelEnum } from '../../enum';

export class PocketBuyInValueModel {
  actualValue: number;
  deposits: number;
  payins: number;
  payoffs: number;
  withdrawals: number;
}

export class PocketValuationModel {
  actualBalance: number;
  balanceForWithdrawal: number;
  buyInValue: PocketBuyInValueModel;
  difference: number;
  marketValue: number;
  taxesByAutomation: number;
}

export class SavingPlanModel {
  amount: number;
  direction: string;
  isActive: boolean;
}

export class PocketModel {
  id: number;
  evergreenPocketId: number;
  active: boolean;
  title: string;
  emoji: string | null;
  isMainPocket: boolean;
  strategySymbol: string;
  riskLevel: RiskLevelEnum | null;
  investmentGoal: number | null;
  type: PocketTypeEnum | null;
  isEmpty: boolean | null;
  deletable: boolean;
  tradesInProgress: boolean;
  valuation: PocketValuationModel;
  savingPlan: SavingPlanModel;
  createdAt: string | null;
  reference: string;
  shiftStatus: string | null;
  temporary: boolean;
  color: string | null;
}

export class VinsafeEarningsInfoModel {
  riskLevel?: 'Level1' | 'Level2' | 'Level3' | 'Level4';
  strategySymbol?: string;
  strategyType?: string;
  strategyId?: number;
  strategySfdr?: string;
  investmentDuration?: 'short' | 'mid' | 'long';
  expectedReturn?: VinsafeExpectedReturnModel;
  exposureEq?: number;
  funds?: VinsafeEarningsFundModel[];
  holdingPeriod?: number;
  maxHoldingPeriod?: number;
  impactRatio?: number | null;
  weightCash?: number;
  weightEq?: number;
  weightFi?: number;
}

export class VinsafeExpectedReturnModel {
  expectedLongtermReturn?: number;
  expectedReturn?: number;
  expectedVolatility?: number;
  fundCosts?: number;
}

export class VinsafeEarningsFundModel {
  isin?: string;
  name?: string;
  sfdr?: string;
  targetWeight?: number;
  ter?: number;
}

export class VinsafeEarningsResponseModel {
  userSelectedEarns?: VinsafeEarningsInfoModel[];
  potentialEarns?: VinsafeEarningsInfoModel[];
}

// ── Advisor depots (GET /vinsafe/depots) ──────────────────────────

export class AdvisorDepotModel {
  clientId: string;
  firstName: string;
  lastName: string;
  email: string;
  iban: string | null;
  lastUpdatedAt: string | null;
  changePercent: number | null;
  balance: number;
}

export class AdvisorDepotsResponseModel {
  clientCount: number;
  depots: AdvisorDepotModel[];
}

// ── Clients without depot (GET /vinsafe/depots/clients-without-depot) ──

export class DepotNudgeClientModel {
  client_id: string;
  firstName: string;
  lastName: string;
  email: string;
  profilePictureUrl: string | null;
  messagesSent: number;
  lastMessageSentAt: string | null;
  // Profile fields for the row subtitle — names requested from backend, not in the spec yet
  age?: number | null;
  occupation?: string | null;
  savingGoalCount?: number | null;
  accountBalance?: number | null;
}

export class DepotNudgeClientsPageModel {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  data: DepotNudgeClientModel[];
}

// ── Nudges (POST /vinsafe/depots/clients/{clientId}/nudge, POST /vinsafe/depots/nudges) ──

export class DepotNudgeRequestModel {
  // {Vorname} is replaced by the client's first name on the backend
  message: string;
}

export class DepotBulkNudgeRequestModel {
  // max. 100 client ids per request
  clientIds: string[];
  // {Vorname} is replaced per client on the backend
  message: string;
}

export class DepotNudgeSendResultModel {
  client_id: string;
  current_message_sent: number;
}

export class DepotBulkNudgeSendResultModel {
  sentCount: number;
  sentClients: DepotNudgeSendResultModel[];
  failedClientIds: string[];
}
